import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client';
import { EVENT_TRIGGERS } from 'automation-ui-enrollment/constants/ProductFeatures';

/**
 * Event Type Definitions
 */

// Mapping from event FQNs to EventMetadataRecord(s)

/**
 * Event Property Definitions
 */

/**
 * Fetches framework builder event types for event triggers
 */
export const GET_EVENT_TRIGGERS_METADATA = registerQuery({
  fieldName: 'eventTriggersMetadata',
  args: [],
  fetcher() {
    return http.get(`framework-builder/v1/read/metadata/types/${EVENT_TRIGGERS}`).then(mapEnrollmentTriggersEventTypes).catch(err => {
      console.error(err);
      throw err;
    });
  }
});
export const GET_EVENT_TRIGGERS_EVENT_PROPERTIES = registerQuery({
  fieldName: 'enrollment_eventTriggersEventProperties',
  args: ['eventFQNOrObjectTypeId'],
  fetcher: ({
    eventFQNOrObjectTypeId
  }) => {
    return http.get(`framework-builder/v1/read/metadata/property/${eventFQNOrObjectTypeId}/${EVENT_TRIGGERS}`).then(mapEnrollmentTriggersEventProperties);
  }
});
function mapEnrollmentTriggersEventTypes(response) {
  // Mapping from event FQN to property name to property value
  const metadataRecord = Object.fromEntries(Object.entries(response).map(([key, {
    metadata
  }]) => [key, Object.fromEntries(Object.entries(metadata).map(([innerKey, {
    value
  }]) => [innerKey, value]))]));
  return metadataRecord;
}
function mapEnrollmentTriggersEventProperties(response) {
  const eventPropertiesRecord = Object.fromEntries(Object.entries(response).map(([key, {
    metadata
  }]) => [key, Object.fromEntries(Object.entries(metadata).map(([innerKey, {
    value
  }]) => [innerKey, value]))]));
  return eventPropertiesRecord;
}